import { SelectValues } from './select-values';

export const companyTypeLabels = {
  media: 'Media',
  regional_media: 'Regioninė media',
  b2b: 'B2B',
  b2g: 'B2G',
} as const;

export type CompanyType = keyof typeof companyTypeLabels;

export const companyTypeOptions: SelectValues[] = [
  { value: 'media', label: companyTypeLabels.media },
  { value: 'regional_media', label: companyTypeLabels.regional_media },
  { value: 'b2b', label: companyTypeLabels.b2b },
  { value: 'b2g', label: companyTypeLabels.b2g },
];

export const getCompanyTypeLabel = (companyType?: string | null): string | undefined => {
  if (!companyType || !Object.prototype.hasOwnProperty.call(companyTypeLabels, companyType)) {
    return undefined;
  }

  return companyTypeLabels[companyType as CompanyType];
};
